module.exports = __webpack_public_path__ + "img/kpmg_100.57b8e2bb.png";